var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "form-group row mt-3 mb-4": _vm.hasTitle } },
    [
      _vm.hasTitle
        ? _c("label-control", {
            staticClass: "col-xs-12 col-sm-5 col-form-label",
            attrs: {
              title: _vm.title,
              required: _vm.required,
              forElement: _vm.title + "_input"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            {
              "col-xs-12 col-sm-7": _vm.hasTitle,
              "dateinput-cell-input": !_vm.hasTitle
            },
            "dateinput"
          ]
        },
        [
          _c(
            "div",
            { class: { "mt-1 mb-4 row": !_vm.inTable } },
            [
              _c("date-input", {
                attrs: {
                  title: _vm.title,
                  name: _vm.name,
                  placeholder: _vm.placeholder,
                  required: _vm.required,
                  rules: _vm.rules,
                  labelledBy: _vm.labelledBy,
                  inTable: _vm.inTable,
                  disabled: _vm.disabled,
                  fullDate: _vm.fullDate
                },
                model: {
                  value: _vm.selectedDate,
                  callback: function($$v) {
                    _vm.selectedDate = $$v
                  },
                  expression: "selectedDate"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "sr-only": _vm.inTable,
                    "outputwrapper col-12 col-md-8 col-lg-9": !_vm.inTable
                  },
                  attrs: {
                    id: _vm.name + "_output",
                    "aria-atomic": "true",
                    "aria-live": "assertive"
                  }
                },
                [
                  _c("div", { staticClass: "v-centering" }, [
                    _c("small", {
                      ref: _vm.title + "_output",
                      staticClass: "d-none"
                    }),
                    _vm._v(" "),
                    _vm.hasTitle
                      ? _c("small", [_vm._v(_vm._s(_vm.selectedString))])
                      : _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.selectedString))
                        ])
                  ])
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }